<template>
    <p class="no-invoicing-data typographies-paragraph-medium-regular">
        {{ title }}
    </p>
</template>
<script>
export default {
    props: {
        content: {
            type: String,
            default: '',
        },
    },
    computed: {
        title() {
            return this.content || this.$t.__('overview.tabs.TabSummary.noInvoicingData');
        },
    },
};
</script>
<style lang="scss" scoped>
.no-invoicing-data {
    margin: 0 0 var(--spacing-3);
}
</style>
